import { IEpletMismatch } from './eplet-mismatches';


export interface IEmpletAllele {
      hlaString: string;
      hlaDisplay: string;
      isInDb: boolean;
      isDr: boolean;
      isDq: boolean;
      isRisk: boolean;
      epletCountAll: number;
      epletCountMismatch: number;
      epletsMismatched: IEpletMismatch[];
}
